export default "__VITE_ASSET__Al71tl5e__"